module.exports = "https://portperrypedals.ca/_res/img/brians_towing.7cb014f.png";